import { Metamodel } from 'app/model/base/model';
import { FormatWriteSettings } from './format-write-settings';
import { IAttribute, ParquetDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.parquet.formatWrite,
    tags: { datasetModel: Metamodel.modelFor(ParquetDataset) }
})
export class ParquetFormatWriteSettings extends FormatWriteSettings {
    public static readonly VERTI_PARQUET: IAttribute;

    @Metamodel.attribute({
        association: 'VERTI_PARQUET',
        templatable: true
    })
    public vertiParquet: boolean = __IS_FABRIC_DPE__ ? true : undefined;
}
